import { TextEditorProps, TextEditorProviderProps } from '@procore/core-react/dist/_typedoc/TextEditor/TextEditor.types.json';
import * as React from 'react';
export default {
  TextEditorProps,
  TextEditorProviderProps,
  React
};